var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrappeGala(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 288 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#29abe2;stroke:#29abe2;stroke-miterlimit:10;stroke-width:0.75px;}.cls-2{fill:#b2855d;}.cls-2,.cls-3{stroke:#765638;stroke-width:5px;}.cls-2,.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;}.cls-3{fill:#efceb4;}.cls-4,.cls-5{fill:none;}.cls-4{stroke:#fff;stroke-width:8px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.47,234.37l-4.94-.74,27-180A2.5,2.5,0,0,1,142,51.7l62-26.59a1,1,0,0,1,1.35.54l1.16,2.7A1,1,0,0,1,206,29.7L145.27,55.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "107 243 89 99 197 99 179 243 107 243"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "191.38 144 197 99 89 99 94.63 144 191.38 144"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "125 117 107 117 116 198"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 288,
    height: 288
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrappeGala);
export default __webpack_public_path__ + "static/media/frappe-gala.4c719f6a251655ad3925ae4098255efa.svg";
export { ForwardRef as ReactComponent };